export function Incinerator() {
    return (
        <div>
        </div>
    );
}
